var map = {
	"./angpao.webp": 2325,
	"./bonus.webp": 2326,
	"./gpi-rebate-m.webp": 2327,
	"./gpi-rebate.webp": 2328,
	"./hublot-watch-2018.webp": 2329,
	"./hublot-watch-2022.webp": 2330,
	"./iphone-13-pro-max.webp": 2331,
	"./iphone-14-pro-max.webp": 2332,
	"./login-to-m.webp": 2333,
	"./login-to.webp": 2334,
	"./mb.webp": 2335,
	"./mg-rebate-m.webp": 2336,
	"./mg-rebate.webp": 2337,
	"./np.webp": 2338,
	"./pointer.webp": 2339,
	"./pp-rebate-m.webp": 2340,
	"./pp-rebate.webp": 2341,
	"./sadface.webp": 2342,
	"./wallet-m.webp": 2343,
	"./wallet.webp": 2344,
	"./wheel-b.webp": 2345,
	"./wheel-btn.webp": 2346,
	"./wheel-indon-b.webp": 2347,
	"./wheel-indon.webp": 2348,
	"./wheel.webp": 2349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 935;